'use client'
import { Printer, Share2, Check } from 'lucide-react'
import { useState } from 'react'

const PrintShareBar = () => {
    const [copied, setCopied] = useState(false)

    const handleShare = () => {
        navigator.clipboard.writeText(window.location.href)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <div className="flex items-center justify-end gap-3 px-6 py-3"
            style={{ background: '#E8F0E8', borderBottom: '1px solid rgba(92,122,92,0.12)' }}>
            <button
                onClick={() => window.print()}
                className="flex items-center gap-1.5 text-xs font-semibold transition-all hover:gap-2"
                style={{ color: '#5C7A5C' }}
            >
                <Printer size={13} /> Print
            </button>
            <div className="w-px h-4" style={{ background: 'rgba(92,122,92,0.2)' }} />
            <button
                onClick={handleShare}
                className="flex items-center gap-1.5 text-xs font-semibold transition-all hover:gap-2"
                style={{ color: copied ? '#2D3E2D' : '#5C7A5C' }}
            >
                {copied ? <Check size={13} /> : <Share2 size={13} />}
                {copied ? 'Copied!' : 'Share'}
            </button>
        </div>
    )
}

export default PrintShareBar
